import { render, staticRenderFns } from "./ManualUpload.vue?vue&type=template&id=1824a3fc&scoped=true"
import script from "./ManualUpload.vue?vue&type=script&lang=js"
export * from "./ManualUpload.vue?vue&type=script&lang=js"
import style0 from "./ManualUpload.vue?vue&type=style&index=0&id=1824a3fc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1824a3fc",
  null
  
)

export default component.exports